import { render, staticRenderFns } from "./CardDelete.vue?vue&type=template&id=1c143414&scoped=true&"
import script from "./CardDelete.vue?vue&type=script&lang=js&"
export * from "./CardDelete.vue?vue&type=script&lang=js&"
import style0 from "./CardDelete.vue?vue&type=style&index=0&id=1c143414&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c143414",
  null
  
)

export default component.exports